import { useMemo } from 'react'
import { useGetLedgerWalletsByCurrencies } from 'hooks/queries/Ledger/useGetLedgerWalletsByCurrencies'
import { LedgerWalletStatuses } from 'types/ledger/ledgerWalletTransactions'

export const useRewardsWallets = (rewardsProductCurrencies: string[]) => {
  const queries = useGetLedgerWalletsByCurrencies(rewardsProductCurrencies, [
    LedgerWalletStatuses.ACTIVE,
  ])

  const rewardsWallets = useMemo(() => {
    return queries.flatMap(query => query.data?.content || [])
  }, [queries])

  const isLoadingWallets = queries.some(query => query.isLoading)

  return {
    rewardsWallets,
    isLoadingWallets,
  }
}
